import '@jonahdigital/jonah_design_system/js';
import $ from 'jquery';
import Utility from './Utility/Utility';
import Str from './Utility/Str';

// -- Expose Utility to window so we can use it in php files
window.Utility = Utility;

/**
 *
 * This class is currently doing more than I would like, but
 * it's just to get us started. We might need to parse
 * this apart differently.
 *
 * */
const App = new class
{
    boot()
    {
        $('html').removeClass('no-js').addClass('js');

        // -- DOM
        this.$lazyImage = $('[data-src]');
        this.$lightboxTriggers = $('[data-fancybox],[target="video"],[target="embed"],[target="popup"]');
        this.$rotator = $('[data-js-hook="rotator"]');

        // -- Data
        this.usingAnimations = window.useSiteAnimations || false;
        this.touchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        this.URL = new URL(window.location.href);
        this.devMode = false;

        this.observer = false;
        this.announcer = null;

        // -- Boot
        this.buildAnnouncer();
        this.bootComponents();
        this.bootSectionBackgroundCheck();
        this.bootLazyLoad();
        this.bootLightboxTriggers();
        this.bootHashLoad();
        this.bootAnimations();
        this.bootPopdownOverrides();
        this.bootAddOns();
        this.bootModals();
        this.bootTelLinkAccessibilityWatcher();
        this.bootImgIframeAccessibilityWatcher();
        this.bootPetPolicyHREFTrigger();
        this.bootEmailReplacement();
        this.bootBodyLockObserver();
        this.bootEmailSignup();
        this.bootRotators();

        if (this.URL.searchParams.has('dev')) {
            let dev = this.URL.searchParams.get('dev');

            if (dev === '1') {
                localStorage.setItem('jd-dev-mode', '1');
            } else {
                localStorage.removeItem('jd-dev-mode');
            }
        }

        if (localStorage.getItem('jd-dev-mode')) {
            this.devMode = true;
        }

        if (this.touchDevice) {
            $('html').addClass('touch-device');

        }

        $(window).on('load', function() {
            $('html').addClass('loaded').removeClass('no-js');
        });

        // import('./Modules/LegacyLogger').then((logger) => {
        //   logger.default.init();
        // });
    }

    /**
     * Page-wide screen reader live region. Components write to it through
     * App.announce() so assistive technology hears state changes (e.g. which
     * place a map is showing) without focus moving.
     */
    buildAnnouncer()
    {
        const el = document.createElement('div');

        el.className = 'sr-only';
        el.setAttribute('role', 'status');

        document.body.appendChild(el);

        this.announcer = el;
    }

    announce(message)
    {
        if (this.announcer) {
            this.announcer.textContent = message;
        }

        return this;
    }

    isProduction()
    {
        return this.devMode === false;
    }

    isDev()
    {
        return this.devMode === true;
    }

    bootComponents(parent = document)
    {
        const currentBottom = window.pageYOffset + window.innerHeight;
        let components = parent.querySelectorAll('[data-component]');
        if (components.length) {
            components.forEach((component) => {
                const top = component.getBoundingClientRect().top + window.pageYOffset;
                const componentClasses = component.getAttribute('data-component').split(',').map((s) => s.trim()).filter(Boolean);
                if (componentClasses.length) {
                    componentClasses.forEach((componentClass) => {
                        const dataName = Str.camelToKebab(componentClass);
                        // Load styles and js for anything already above or in the viewport
                        if (top <= currentBottom || jcms.first_sections.includes(componentClass)) {
                            this.loadComponentStyles(componentClass, component, dataName);
                            this.loadComponentJs(componentClass, component, dataName);
                        } else {
                            this.bootComponent(componentClass, component, dataName);
                        }
                    });
                }
            });
        }
    }

    bootComponent(componentClass, component, dataName)
    {
        // Load component css and js when the component is within 200px of the viewport
        Utility.elementInViewport(component, () => {
            this.loadComponentStyles(componentClass, component, dataName);
            this.loadComponentJs(componentClass, component, dataName);
        }, { rootMargin: '200px 0px', threshold: 0 });
    }

    loadComponentStyles(componentClass, component, dataName)
    {
        if ($(component).attr('data-css-loaded')) {
            return;
        }
        this.loadCss(componentClass).then(() => {
            $(component).css('visibility', 'visible');
        }).catch((err) => {
            if (this.isDev()) {
                console.warn('Premium One: Component css not found or failed to load:', componentClass, err);
            }
        }).finally(() => {
            $(component).attr('data-css-loaded', 'true');
        });
    }

    loadComponentJs(componentClass, component, dataName)
    {
        if ($(component).attr('data-js-loaded')) {
            return;
        }
        import(ROOT_PATH + '/js/Components/' + componentClass).then((module) => {
            $(component).css('visibility', 'visible');
            $(component).attr('data-js-loaded', 'true');

            let instance = typeof module.default === 'function' ?
                new [module.default][0]($(component), this.getArgObject(component))
                :
                module.default.boot($(component), this.getArgObject(component));

            if (instance) {
                $(component).data('__jd-component-' + dataName, instance);
            }
        }).catch((err) => {
            if (this.isDev()) {
                console.warn('Premium One: Component js not found or failed to load:', componentClass, err);
            }
        });
    }

    importVendor(filename, jqueryScope = true)
    {
        if (typeof filename === 'string') {
            return import(`${ROOT_PATH}/js/Vendor/${filename}`);
        }

        // If an array of vendor filenames was passed
        if (Array.isArray(filename)) {
            return Promise.all(
                filename.map((f) => import(`${ROOT_PATH}/js/Vendor/${f}`)),
            );
        }

        // If an object was passed, import all of its values
        if (filename && typeof filename === 'object') {
            const files = Object.values(filename);
            return Promise.all(
                files.map((f) => import(`${ROOT_PATH}/js/Vendor/${f}`)),
            );
        }

        // Fallback: return a resolved Promise for non-supported inputs
        return Promise.resolve();
    }

    loadCss(componentClass, vendor = false)
    {
        return new Promise((resolve, reject) => {
            try {
                const href = window.location.origin + DIST_PATH + '/' + (vendor ? 'vendors/' : '') + componentClass + '.css';

                // Check if it's already loaded
                let existing = document.querySelector('link[rel="stylesheet"][data-component-style="' + (vendor ? 'vendor-' : '') + componentClass + '"]');

                if (!existing) {
                    existing = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).find((l) => l.href && l.href.indexOf(href) !== -1);
                }

                if (existing) {
                    resolve();
                    return;
                }

                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                link.setAttribute('data-component-style', (vendor ? 'vendor-' : '') + componentClass);
                link.onload = () => resolve();
                link.onerror = (e) => reject(e);

                const themeStyles = document.getElementById('jd-theme-styles');
                if (themeStyles && themeStyles.parentNode === document.head) {
                    document.head.insertBefore(link, themeStyles);
                } else {
                    document.head.appendChild(link);
                }
            } catch (e) {
                reject(e);
            }
        });
    }

    getArgObject(element)
    {
        let argAttrs = element.getAttributeNames().filter((arg) => arg.match(/^data-arg-/));
        let args = {};

        if (argAttrs.length) {
            argAttrs.forEach((argName) => {
                let argProp = argName.replace(/^data-arg-/, '').replace(/-([a-z])/g, function(g) {
                    return g[1].toUpperCase();
                });
                args[argProp] = element.getAttribute(argName);

                if (typeof args[argProp] === 'string') {
                    if (args[argProp] === 'true') {
                        args[argProp] = true;
                    } else if (args[argProp] === 'false') {
                        args[argProp] = false;
                    }
                }

                // element.removeAttribute(argName);
            });
        }

        return args;
    }

    bootAnimations()
    {
        if (this.usingAnimations) {
            this.importVendor('wow').then((module) => {
                let wow = new module.WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 100,
                    mobile: false,
                    live: false,
                });

                $('html').data('wow', wow);

                wow.init();
            });
        }
    }

    bootLazyLoad()
    {
        this.importVendor('lazyload').then((module) => {
            var myLazyLoad = new module.default();
            var myLazyLoadBG = new module.default({ elements_selector: '.lazy' });
        });
    }

    bootLightboxTriggers()
    {
        if (this.$lightboxTriggers.length) {
            this.loadCss('fancybox', true);
            this.importVendor('fancybox').then(() => {
                this.$lightboxTriggers.each(function() {
                    let url = $(this).attr('href');
                    let target = $(this).attr('target');
                    let wistia = url.match(/wistia/);

                    if (target === 'embed' || wistia) {
                        $(this).attr('data-type', 'iframe');

                        if (!$(this).attr('data-src')) {
                            $(this).attr('data-src', url).attr('href', 'javascript:void(0)');
                        }
                    }

                    if (wistia) {
                        $(this).data('as-video', 1);
                    }
                });

                this.$lightboxTriggers.fancybox({
                    idleTime: 60,
                    loop: true,
                    transitionEffect: 'slide',
                    buttons: ['close'],
                    wheel: false,

                    beforeLoad: function() {
                        $('.fancybox-container').css('z-index', Utility.maxZ() + 1);
                    },
                    afterLoad: function(instance, current) {
                        // -- The "orig" or "thumb" on the "current" object is wrong. Have to get from
                        // -- the instance group index. Don't change.
                        let $thumb = instance.group[instance.currIndex].$thumb;

                        if (current.type === 'image' && $thumb && $thumb.length) {
                            current.$image.attr('alt', $thumb.attr('alt')).attr('title', $thumb.attr('title'));
                        }
                    },
                    afterShow: function(instance) {
                        // a11y: Fancybox only autofocuses html content, so move keyboard
                        // focus to the close button ourselves when the lightbox opens
                        if (instance.firstRun) {
                            instance.$refs.container.find('[data-fancybox-close]:visible').first().trigger('focus');
                        }
                    },
                    beforeShow: function(instance) {
                        let $trigger = instance.group[instance.currIndex].opts.$orig;
                        if ($trigger.data('as-video')) {
                            instance.$refs.stage.addClass('video');
                        }

                        /**
                         * !instance.firstRun means this is a slide event inside the
                         * lightbox, and does not fire when clicking a thumbnail to
                         * launch -- JDL watches the click event for that initial
                         * engagement and fires an identical impression.
                         */
                        if (!instance.firstRun && window.JDLEvent?.dispatch) {
                            const currentSlideThumbEl = instance?.current?.$thumb?.parents('a[data-jdl-data]').get(0);

                            if (currentSlideThumbEl) {
                                const data = JSON.parse(currentSlideThumbEl.dataset.jdlData);
                                window.JDLEvent?.dispatch(window.JDLEvent.DispatchKey.GalleryImpression, Object.assign(data, {in_lightbox: true}));
                            }
                        }
                    }
                });
            });
        }
    }

    bootHashLoad()
    {
        const initialScrollSpeed = 'slow';
        const secondScrollSpeed = 'fast';

        $(document).on('click', 'a[href*="#"]', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const element = event.currentTarget;
            const href = $(element).attr('href');

            let dest = href.replace(window.location.origin, '');
            if (dest.indexOf('/') === 0) {
                dest = dest.replace('/', '');
            }
            if (dest.indexOf('#') === 0) {
                dest = dest.replace('#', '');
            }

            const $dest = dest.indexOf('http') !== 0 ? $('#' + dest) : undefined;
            if (typeof $dest != 'undefined' && $dest.length) {
                let offset = Utility.getOffset($dest);
                $('html,body').animate({
                    scrollTop: offset,
                }, initialScrollSpeed, () => {
                    offset = Utility.getOffset($dest);
                    $('html,body').animate({
                        scrollTop: offset,
                    }, secondScrollSpeed, () => {
                        window.location.hash = dest;
                    });
                });
            } else {
                window.open(href, $(element).attr('target') ? $(element).attr('target') : '_self');
            }
        });

        $(window).on('load', function() {
            if (typeof window.location.hash != 'undefined') {
                let hash = window.location.hash.replace(/^\/|\/$/g, '');
                let $hash = $(hash);

                if ($hash.length && $hash.is(':visible')) {
                    let offset = Utility.getOffset($hash);
                    $('html,body').animate({
                        scrollTop: offset,
                    }, initialScrollSpeed, () => {
                        offset = Utility.getOffset($hash);
                        $('html,body').animate({
                            scrollTop: offset,
                        }, secondScrollSpeed);
                    });
                }
            }
        });
    }

    bootPopdownOverrides()
    {
        if (this.popdownActive()) {
            this.loadCss('PopDown');
            JonahPopdown.on('load', () => {
                $('.popdown__button-item').each(function(index, element) {
                    if (index === 0) {
                        $(this).addClass('btn btn-primary');
                    } else {
                        $(this).addClass('btn btn-secondary');
                    }
                    if (!$(this).find('span').length) {
                        const text = $(this).text();
                        $(this).html('<span class="vertaligner-btn">' + text + '</span>');
                    }
                });
                $('html').removeClass('cloak-header');
            });
        } else {
            $('html').removeClass('cloak-header');
        }
    }

    /**
     * Boot add on resources.
     *
     * Tour Scheduler is a bit weird and relies on resources being
     * available on the parent, which it shouldn't, but here
     * we are.
     */
    bootAddOns()
    {
        if (typeof addOnResources !== 'undefined') {
            for (let name in addOnResources) {
                let settings = addOnResources[name];
                let injectJSResources = settings.boot === true || settings.selector && $(settings.selector).length;

                if (injectJSResources) {
                    if (name === 'tour_scheduler') {
                        Promise.all([
                            this.importVendor('pickadate'),
                            this.importVendor('formulate'),
                            this.importVendor('infield'),
                        ]).then(() => {
                            settings.js.forEach((script) => $.getScript(script));

                            // -- Tour scheduler does not manage its own infield labels
                            $('#tourSchedulerModal').find('[data-infield-label]').inFieldLabels();
                        });
                    } else {
                        settings.js.forEach((script) => $.getScript(script));
                    }
                }
            }
        }
    }

    /**
     * Todo: make modals their own components eventually
     */
    bootModals()
    {
        let options = $.extend({
            $toggle: $('[data-modal-open]'),
            $modal: $('[data-modal-id]'),
            staticZ: false,
            on: {
                open: null,
                beforeOpen: null,
                close: null,
                beforeClose: null,
            },
        }, {});

        options.$modal.on('modal-event', function(e, name, data) {
            var event = options.on[name];

            if (event) {
                event();
            }
        }).on('open', function(e, trigger) {
            if (!$(this).data('open')) {
                options.$modal.trigger('modal-event', ['beforeOpen', { trigger: trigger }]);

                $(this).attr('aria-hidden', 'false').attr('aria-modal', 'true');

                $(this).fadeIn(200, function() {
                    options.$modal.trigger('modal-event', ['open', { trigger: trigger }]);

                    // a11y: move keyboard focus into the dialog, close button first
                    var $close = $(this).find('[data-modal-close]').first();

                    if ($close.length) {
                        $close.get(0).focus();
                    } else {
                        $(this).attr('tabindex', '-1');
                        this.focus();
                    }
                });

                $('html').addClass('modal-open');

                if (typeof $(this).attr('data-modal-lock') == 'undefined' || $(this).data('modal-lock') === true) {
                    Utility.lockBody();
                }

                if (options.staticZ) {
                    if (!$(this).data('z-index')) {
                        $(this).data('z-index', Utility.maxZ() + 1);
                    }
                } else {
                    $(this).data('z-index', Utility.maxZ() + 1);
                }

                $(this).css('z-index', $(this).data('z-index'));

                $(this).data('open', true);
                $(this).data('trigger', trigger);
            }

            if (!$(this).data('bound-ui')) {
                $(this).data('bound-ui', true);

                $(document).keyup(function(e) {
                    if (e.key === 'Escape') {
                        options.$modal.trigger('close');
                    }
                });

                $(this).find('[data-modal-close]').click(function(e) {
                    e.preventDefault();

                    $(this).trigger('close');
                });

                $(this).click(function(e) {
                    var $parentContent = $(e.target).parents().filter('[data-modal-content]');

                    if (!$parentContent.length) {
                        $(this).trigger('close');
                    }
                });

                // Close modal when clicking buttons or links inside (using delegation to bind once)
                $(this).on('click', 'button, a', function() {
                    options.$modal.trigger('close');
                });

                // a11y: trap Tab focus within the dialog while it is open
                $(this).on('keydown', function(e) {
                    if (e.key !== 'Tab') {
                        return;
                    }

                    var $focusable = $(this).find(
                        'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                    ).filter(':visible');

                    if (!$focusable.length) {
                        e.preventDefault();
                        return;
                    }

                    var first = $focusable.get(0);
                    var last = $focusable.get($focusable.length - 1);

                    if (e.shiftKey && document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    } else if (!e.shiftKey && document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                });
            }
        }).on('close', function() {
            if ($(this).data('open')) {
                options.$modal.trigger('modal-event', ['beforeClose']);

                $(this).fadeOut(200, function() {
                    options.$modal.trigger('modal-event', ['close']);
                    $(this).css('z-index', '');
                });

                $('html').removeClass('modal-open');

                if (typeof $(this).attr('data-modal-lock') == 'undefined' || $(this).data('modal-lock') === true) {
                    Utility.releaseBody();
                }

                $(this).attr('aria-hidden', 'true').removeAttr('aria-modal');

                $(this).data('open', false);

                var $trigger = $(this).data('trigger');

                // a11y: return focus to the element that opened the dialog
                if ($trigger?.length) {
                    $trigger.get(0).focus();
                }

                // Fire JDL amenity collapse event when closing an amenity modal
                var modalId = $(this).attr('data-modal-id') || '';
                if (modalId.indexOf('amenity-') === 0 && window.JDLEvent?.dispatch) {
                    var jdlData = $trigger?.length ? JSON.parse($trigger.attr('data-jdl-data') || '{}') : {};
                    window.JDLEvent.dispatch(window.JDLEvent.DispatchKey.AmenitiesCollapsed, jdlData);
                }
            }
        });

        if (options.$toggle && options.$toggle.length) {
            options.$toggle.click(function(e) {
                e.preventDefault();

                if (!$(this).data('modal')) {
                    $(this).data('modal', options.$modal.filter('[data-modal-id="' + $(this).data('modal-open') + '"]'));
                }

                if ($(this).data('modal').length) {
                    $(this).data('modal').trigger('open', [$(this)]);
                }
            });
        }
    }

    getScrollOffset()
    {
        let $stickyHeader = $('#sticky-header');
        let useOffset = Boolean($stickyHeader.length);
        let scrollTop = $(window).scrollTop();

        if (useOffset) {
            return $stickyHeader.length ? $stickyHeader.outerHeight() : 0;
        }

        return 0;
    }

    header()
    {
        if (this.componentExists('Header')) {
            return this.getComponent('Header');
        }

        return new Promise((resolve) => {
            resolve(null);
        });
    }

    stickyHeader()
    {
        if (this.componentExists('StickyHeader')) {
            return this.getComponent('StickyHeader');
        }

        return new Promise((resolve) => {
            resolve(null);
        });
    }

    hero()
    {
        if (this.componentExists('Hero')) {
            return this.getComponent('Hero');
        }

        return new Promise((resolve) => {
            resolve(null);
        });
    }

    subpageBanner()
    {
        if (this.componentExists('SubpageBanner')) {
            return this.getComponent('SubpageBanner');
        }

        return new Promise((resolve) => {
            resolve(null);
        });
    }

    componentExists(componentClass, filterByComponentId = null)
    {
        let $search = $('[data-component]').filter((index, element) => {
            return element.getAttribute('data-component').replace(/\s/, '').match(new RegExp(`(?:^|,)${componentClass}(?:,|$)`));
        });

        if (filterByComponentId) {
            $search = $search.filter('[data-component-id="' + filterByComponentId + '"]');
        }

        return Boolean($search.length > 0);
    }

    getComponent(componentClass, filterByComponentId = null)
    {
        let $elements = $('[data-component]').filter((index, element) => {
            return element.getAttribute('data-component').replace(/\s/, '').match(new RegExp(`(?:^|,)${componentClass}(?:,|$)`));
        });

        if (filterByComponentId) {
            $elements = $elements.filter('[data-component-id="' + filterByComponentId + '"]');
        }

        return Utility.waitForDefined(() => {
            return $elements.first().data('__jd-component-' + Str.camelToKebab(componentClass));
        });
    }

    getComponentInstancesFromEl(element)
    {
        let promises = [];
        let componentList = $(element).data('__jd-component-list');

        if (componentList.length) {
            componentList.forEach((componentClass) => {
                promises.push(Utility.waitForDefined(() => {
                    return $(element).data('__jd-component-' + Str.camelToKebab(componentClass));
                }));
            });
        }

        return Promise.all(promises);
    }

    getComponentInstanceFromEl(element, componentClass)
    {
        let componentList = $(element).data('__jd-component-list');

        if (componentList.length && componentList.indexOf(componentClass) > -1) {
            return Utility.waitForDefined(() => {
                return $(element).data('__jd-component-' + Str.camelToKebab(componentClass));
            });
        }

        return new Promise((resolve) => {
            resolve(null);
        });
    }

    bootSectionBackgroundCheck()
    {
        $('[data-section]').each((index, element) => {
            const $element = $(element);
            const color = element.getAttribute('data-bg');
            const $next = $element.next();
            const nextColor = $next.length ? $next.attr('data-bg') : null;
            if (color && nextColor && color.length && nextColor.length && color === nextColor) {
                $next.addClass('bg-match');
            } else {
                $next.removeClass('bg-match');
            }
        });
    }

    popdownActive()
    {
        return typeof JonahPopdown != 'undefined';
    }

    bootEmailReplacement()
    {
        $('[data-mail-name]').each((index, element) => {
            let $element = $(element);
            let email = $element.data('mail-name') + '@' + $element.data('mail-host');

            if ($element.text() === '') {
                $element.text(email);
            }

            $element.attr('href', 'mailto:' + email).removeAttr('data-mail-name').removeAttr('data-mail-host');
        });
    }

    bootImgIframeAccessibilityWatcher()
    {
        let imgCheckIteration = 0;

        let runImgiFrameCheck = function() {
            $('img,iframe').each(function() {
                if (!$(this).attr('alt') && !$(this).attr('title') && $(this).attr('role') != 'presentation') {
                    $(this).attr('role', 'presentation').attr('aria-hidden', true);
                }
            });
        };

        runImgiFrameCheck();

        let interval = setInterval(function() {
            if (imgCheckIteration === 20) {
                clearTimeout(interval);
            }

            ++imgCheckIteration;
            runImgiFrameCheck();
        }, 500);
    }

    bootTelLinkAccessibilityWatcher()
    {
        let checkIteration = 0;

        let runPhoneLinkCheck = function(callback) {
            $('[href^=tel]').each(function() {
                let phoneText = $(this).text().trim();

                if (!$(this).data('original-phone-text')) {
                    $(this).data('original-phone-text', phoneText);
                }

                if (phoneText !== $(this).data('original-phone-text')) {
                    callback();

                    $(this).attr('aria-label', 'Call us at ' + phoneText);
                }
            });
        };

        // -- Run immediately
        runPhoneLinkCheck();

        // -- Run twice a second for ten seconds.
        let phoneCheckInterval = setInterval(function() {
            if (checkIteration === 20) {
                clearInterval(phoneCheckInterval);
            }

            runPhoneLinkCheck(function() {
                clearInterval(phoneCheckInterval);
            });

            ++checkIteration;
        }, 500);
    }

    bootPetPolicyHREFTrigger()
    {
        if ($('[href*="#pet-policy"]').length && $('[data-modal-open="pet-policy"]').length) {
            $('[href*="#pet-policy"]').click(function(e) {
                e.preventDefault();
                $('[data-modal-open="pet-policy"]').trigger('click');
            });
        }
    }

    bootBodyLockObserver()
    {
        const targetElement = document.querySelector('body');

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    if (!targetElement.classList.contains('ignore-sticky-header-cloak')) {
                        const computedStyle = getComputedStyle(targetElement);
                        const newPropertyValue = computedStyle.getPropertyValue('position'); // Example: watching 'display'

                        if (newPropertyValue === 'fixed') {
                            this.stickyHeader().then((StickyHeader) => {
                                if (StickyHeader) {
                                    StickyHeader.cloak();
                                }
                            });

                        } else {
                            this.stickyHeader().then((StickyHeader) => {
                                if (StickyHeader) {
                                    StickyHeader.uncloak();
                                }
                            });
                        }
                    }

                    break;
                }
            }
        });

        observer.observe(targetElement, { attributes: true, attributeFilter: ['style'] });
    }

    bootEmailSignup()
    {
        if (typeof jcms.email_signup_settings != 'undefined') {
            import(ROOT_PATH + '/js/Components/EmailSignup').then((module) => {
                const EmailSignup = new module.default();
            });
        }
    }

    bootRotators()
    {
        if (this.$rotator.length === 0) {
            return;
        }

        App.loadCss('flexslider', true).then(() => {
            App.importVendor('flexslider').then(() => {
                this.$rotator.each((index, element) => {
                    var navType = $(element).data('nav');
                    var controlNav = navType === 'control' ? true : false;
                    var directionNav = navType === 'direction' ? true : (navType ? false : true);
                    $(element).flexslider({
                        controlNav: controlNav,
                        directionNav: directionNav,
                        start: (slider) => {
                            if (slider.count < 2) {
                                if (typeof slider.controlNavScaffold != 'undefined') {
                                    slider.controlNavScaffold.remove();
                                }
                                if (slider.directionNav && typeof slider.directionNav[0] != 'undefined') {
                                    $(slider.directionNav[0]).closest('ul').remove();
                                }
                            }
                        },
                        after:        (slider) => {
                            let img = slider.slides?.[slider.currentSlide]?.querySelector('img');

                            if (img && !slider.playing) {
                                const data = img.dataset?.jdlData;

                                if (data && window.JDLEvent?.dispatch) {
                                    window.JDLEvent.dispatch(JDLEvent.DispatchKey.GalleryImpression, JSON.parse(data));
                                }
                            }
                        }
                    });
                });
            });
        });
    }
};

export default App;
